// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","subcategory":"_35C5rcMVwqJTsfXZ42FfVS","subcategoryName":"_1S8x1Fw6wN78ZzsaFTqK2M"};